module.exports = __webpack_public_path__ + "media/images/flags/li-8962ced79a52bbfa0ba8522cc0740009.svg";